import useAuth from "@/pages/user/auth/@context/useAuth";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoute = () => {
  const { auth, loading } = useAuth();
  const { pathname } = useLocation();
  const isAuthenticated = Boolean(auth?.user);
  // const isAuthenticated = true; // for test

  if (!loading && !isAuthenticated) {
    return <Navigate to="/signin" replace state={{ from: { pathname } }} />;
  }

  return <Outlet />;
};

export default PrivateRoute;
